import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageTitle from "../../../../components/pageTitle";
import {
  handleBuyAllUsers,
  resetAllBuySummeryData,
} from "../../../../redux/actoin";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import CreateUser from "./form";

const CreateCustomerBuy = () => {
  const [data, setData] = useState({});
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const AllUsersBuy = useSelector((state) => state.AllUsersBuy);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSumbit = () => {
    setLoadingSubmit(true);
    axiosInstance
      .post(
        API.info.customerSingleBuy,
        {
          ...data,

          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          dispatch(resetAllBuySummeryData());

          if (AllUsersBuy.users?.page) {
            axiosInstance
              .get(
                API.info.customerItemBuy +
                  `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${res?.data.data}`,
                {
                  headers: {
                    Authorization: `Bearer ${userInfo?.token}`,
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                    "Accept-Language": "fa-IR",
                    chHostName: process.env.REACT_APP_CHHOSTNAME,
                  },
                }
              )
              .then((res) => {
                var temp = [...AllUsersBuy.users?.customers];
                temp.unshift(res?.data?.data);
                dispatch(
                  handleBuyAllUsers({
                    ...AllUsersBuy.users,
                    customers: temp,
                  })
                );
                navigate("/buy/customer");

                toast.success(res?.data?.message);
              })
              .catch((err) => {
                toast.error(res?.data?.message);
              });
          } else {
            navigate("/buy/customer");
            toast.success(res?.data?.message);
          }
        } else {
          toast.error(res?.data?.message);
        }
        setLoadingSubmit(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoadingSubmit(false);
        /*         if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  useEffect(() => {
    axiosInstance
      .get(API.info.sellersLast + `?guidStateRecNo=${company?.guidRecNo}`, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setData({ ...data, chSaleSoftID: res.data.data.chNextSaleSoftID });
      })
      .catch((err) => {});
  }, []);
  return (
    <>
      {" "}
      <PageTitle
        broadCrumb={[
          {
            title: "خرید",
            path: "/buy",
          },
          {
            title: "فروشندگان",
            path: "/buy/customer",
          },
        ]}
        title={"ساخت فروشنده"}
      />
      <CreateUser
        data={data}
        setData={setData}
        handleSumbit={handleSumbit}
        loadingSubmit={loadingSubmit}
      />
    </>
  );
};

export default CreateCustomerBuy;
